var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"pt-4",staticStyle:{"width":"18rem"}},[_c('img',{staticClass:"card-img-top",attrs:{"src":_vm.logo,"alt":_vm.logoAlt}}),_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"card-text text-center lead"},[_vm._v(_vm._s(_vm.logoDevise))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }